import { FC } from "react";
import { ColorValue, StyleSheet, View } from "react-native";
import { kColors } from "../kColors";

interface tProps {
  color?: ColorValue;
  width?: number;
}

const HorizontalRule: FC<tProps> = ({ color, width }) => {
  return (
    <View
      style={[styles.horizontalRule, { borderBottomColor: color || kColors.black, borderBottomWidth: width || 1 }]}
    />
  );
};

export default HorizontalRule;

const styles = StyleSheet.create({
  horizontalRule: {
    marginBottom: 16,
  },
});
